import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { VesselCalculationInventoryService } from 'src/app/services/danish-shipping-services/vessel-calculation-inventory.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-scenario-category-create',
  templateUrl: './scenario-category-create.component.html',
  styleUrls: ['./scenario-category-create.component.css']
})
export class ScenarioCategoryCreateComponent  {
  category = { Title: '', Scenario: { Id: null } };
  isSubmitting = false;
  scenarios: any[] = [];  

  constructor(private scenarioCategoryService: VesselCalculationInventoryService, private toastr: ToastrService,     private route: ActivatedRoute,
      private router: Router,) {}

  ngOnInit(): void {
    this.scenarioCategoryService.getScenarioCategory().subscribe(
      (response) => {
        this.scenarios = response.filter((value, index, self) =>
          index === self.findIndex((t) => t.scenario.id === value.scenario.id)
        );
      },
      (error) => {
        console.error('Error loading scenarios:', error);
      }
    );
  }
  

  createCategory(): void {
    if (!this.category.Title || !this.category.Scenario.Id) {
      this.toastr.warning('Please fill in all fields.');
      return;
    }
  
    this.isSubmitting = true;
    this.scenarioCategoryService.createScenarioCategory(this.category).subscribe(
      response => {
        console.log('Category created:', response);
        this.toastr.success('Scenario Category created successfully!');
        this.category = { Title: '', Scenario: { Id: null } };
        this.router.navigate(['/homeAdmin/v2/scenarioCategory']); 

      },
      error => {
        console.error('Error creating category:', error);
        this.toastr.error('Failed to create category.');
      }
    ).add(() => this.isSubmitting = false);
  }
}